import React, { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { listuserSuperadmin, toggleSuperadmin } from '../Network/Administration'
import { Loading, Toggle, UserProfileImage } from '../Library'
import { AlertModalContext } from '../Library/AlertModalContext'
import "./SuperadminAssign.css"

function SuperadminAssign() {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const [isLoading, setIsLoading] = useState(false)
    const [userlist, setUserlist] = useState([])

    const fetchUserlist = () => {
        setIsLoading(true)
        listuserSuperadmin(
            (data) => {
                setUserlist(data)
                setIsLoading(false)
            },
            (error) => {
                setIsLoading(false)
            }
        )
    }

    const onToggleSuperadmin = (userId, name, isSuperadmin) => {
        if(isSuperadmin){
            alertModal.setTitle(lang.superadmin)
            alertModal.setDescription(`${lang.assign_super_admin} ${name} ${lang.give_super_admin}`)
            alertModal.setAlertType("WARNING")
            alertModal.setButton([
                {
                    title: langCx.lang.confirm.ok,
                    variant: "primary",
                    onClick: ()=>{ 
                        alertModal.setIsShow(false)
                        setIsLoading(true)
                        toggleSuperadmin(userId, isSuperadmin,
                            (data)=>{
                                setIsLoading(false)
                                fetchUserlist(true)
                            },
                            (error)=>{
                                setIsLoading(false)
                            })
                    }
                },
                {
                    title: langCx.lang.confirm.cancel,
                    variant: "secondary",
                    onClick: ()=>{ 
                        alertModal.setIsShow(false) 
                    }
                }
            ])
            alertModal.setIsShow(true)
        }else{
            toggleSuperadmin(userId, isSuperadmin,
                (data)=>{
                    setIsLoading(false)
                    fetchUserlist(true)
                },
                (error)=>{
                    setIsLoading(false)
                })
        }
        
    }

    useEffect(()=>{
        fetchUserlist()
    },[])

    return (
        <div id="super-admin">
            { isLoading ? <Loading/>: null }
            <div>{lang.superadmin_desc}</div>
            <div className='content-container'>
                { userlist.map((item, key) =>
                <UserItem
                key={key}
                name={`${item.firstName} ${item.lastName}`}
                email={item.email}
                profileImagePath={item.profileImagePath}
                isSuperadmin={item.isSuperAdmin}
                onToggle={()=>{
                    onToggleSuperadmin(
                        item.id, 
                        `${item.firstName} ${item.lastName}`,
                        !item.isSuperAdmin ? true:false)
                }}
                />
                )}
            </div>
        </div>
    )
}

function UserItem({ name, email, profileImagePath, isSuperadmin, onToggle }){
    return(
        <div className='user-item'>
            <div>
                <UserProfileImage
                profileImagePath={profileImagePath}
                width={40}
                height={40}
                />
            </div>
            <div className='content-user'>
                <div className='title'>{name}</div>
                <div className='desc'>{email}</div>
            </div>
            <div>
                <Toggle
                isTurnon={isSuperadmin}
                onChange={onToggle}
                />
            </div>
        </div>
    )
}

export default SuperadminAssign
